import { BasicClient } from "@/utils/httpClient";

export default class Pickup {
  client
  constructor() {
    this.client = new BasicClient()
  }

  getEforms () {
    return this.client.exec('/pickup-eforms/user', 'GET')
  }

  createEform (id) {

    const body = {
      idpickupeform: id
    }

    return this.client.exec('/pickup-eforms/create', 'POST', body)
  }

  sendEform (hash, id) {
    const body = {
      idpickupeform: id
    }

    return this.client.exec(`/pickup-eforms/send/${hash}`, 'POST', body)
  }
}